import React from "react"
import { Row, Col, Container } from "react-bootstrap"
import { graphql, useStaticQuery } from "gatsby"
import nft2 from "../assets/images/nft2.png"

const NFTIntro2 = () => {
  const data = useStaticQuery(graphql`
    {
      strapiHomePage {
        nft_intro2_description1
        nft_intro2_description2
      }
    }
  `)

  const {
    strapiHomePage: { nft_intro2_description1, nft_intro2_description2 },
  } = data

  return (
    <Container className="nft-intro2">
      <Row className="align-items-center">
        <Col lg={6} className="order-2 order-lg-1">
          <p>{nft_intro2_description1}</p>
          <p>{nft_intro2_description2}</p>
        </Col>
        <Col lg={6} className="nft-intro2-img order-1 order-lg-2">
          <img src={nft2} alt="nft2" className="img-fluid nft2-img" />
        </Col>
      </Row>
    </Container>
  )
}

export default NFTIntro2
